import moderationSlice from './slice';

const moderationReducer = moderationSlice.reducer;

export default moderationReducer;
